import React, {useEffect, useState} from 'react';
import './Band.scss';
import Buttons from '../common/Buttons';

const Band = ({ band, onSelectedBand }) => {


  const [ accordionIndex, setAccordionIndex ] = useState(0);
  const [ accordionChildIndex, setAccordionChildIndex ] = useState();
  const [ selectedOption, setSelectedOption ] = useState();
  const [ selectedBand, setSelectedBand] =  useState()
  const [isCorrectClass, setIsCorrectClass ] =  useState('')
  const [buttonCaption, setButtonCaption ] = useState('Confirm')


  const changeAccordionTab = (index) => {
    setAccordionChildIndex();
    setAccordionIndex(index);
  }

  const handleInputClick = (e) => {
    setSelectedOption(e.target.value)
    const sband = band.accordion.find(b => b.title === e.target.value);
    setIsCorrectClass(sband.isCorrect === true ? 'right' : 'wrong');

    console.log(sband);
    setSelectedBand(sband)
  }

  const handleButtonClick =() => {
    if (selectedBand) {
      onSelectedBand(selectedBand)
    }
  }
  const handleTryAgainClick =  () => {
      setSelectedBand()
  }
  useEffect(() => {
  }, [selectedOption])
  useEffect(() => {
  },[selectedBand])


  return (
    <div className="band-container">
      <div className="band-body">
        <div className="accordion">
          { band.accordion &&
            band.accordion.map( (item, index) => (
              <React.Fragment key={item.title}>
                <div className={`accordion-tab ${ accordionIndex === index ? 'active' : '' }`} onClick={ () => { changeAccordionTab(index) } }>{item.title}</div>
                <div className={`accordion-body ${ accordionIndex === index ? 'active' : '' }`}>
                  <span dangerouslySetInnerHTML={{__html: item.body}}/>
                  { item.accordion &&
                    item.accordion.map( (subItem, subIndex) => (
                      <React.Fragment key={subItem.title}>
                        <div className={`accordion-tab ${ accordionChildIndex === subIndex ? 'active' : '' }`} onClick={ () => { setAccordionChildIndex(subIndex) } }>{subItem.title}</div>
                        <div className={`accordion-body ${ accordionChildIndex === subIndex ? 'active' : '' }`}>
                        <span dangerouslySetInnerHTML={{__html: subItem.body}}/>
                        </div>
                      </React.Fragment>
                    ))
                  }
                </div>
              </React.Fragment>
            ))
          }
        </div>
        <div className="decisions">
          <div className={'decisions-band-title'}>Choose a band for this mission's comms</div>
            <div className={'decisions-band'} >
              
              {band.accordion && band.accordion.map( b => (
                  <div key={b.title} className={'decisions-band-item'}>
                   <input onChange={handleInputClick} className={'decisions-band-item-checkbox'} type="radio" name="band" id={b.title} value={b.title} />
                    <label htmlFor={b.title} className={'decisions-band-item-label'}>{b.title}</label>
                    {selectedBand && selectedBand.title === b.title ? <div className={`decisions-band-iscorrect ${isCorrectClass}`}>
                        &nbsp;
                    </div> : <div className={`decisions-band-iscorrect`} /> }

                  </div>
                ))}
              <div className={`decisions-band-submit-button button ${isCorrectClass !== 'right' && 'disabled' }`} onClick={handleButtonClick}>{buttonCaption}</div>
            </div>
        </div>
        <div className={"feedback"} >
          <div className={'feedback-content'} dangerouslySetInnerHTML={ {
            __html: selectedBand?.feedback || ''
          }} />
          { selectedBand && selectedBand.isCorrect === false && <div className={'feedback-tryagain-button'} onClick={handleTryAgainClick}>
            Try Again
          </div>}
        </div>
      </div>
    </div>
  );
}

export default Band;
